import type { Choice } from "@memorang/types/src/session/new-session";
const getSortedChoices = (choiceList: Choice[]) => {
	const correctChoices = choiceList.filter(({ isCorrect }) => isCorrect);
	return correctChoices;
};

export { getSortedChoices };
